/**
 * Tabblad Agent-rollen: per rol de kansparameters en de antwoordlengte.
 * Sinds de PO-versie is dit de enige plek waar die worden ingesteld.
 */
import React, { useEffect, useState } from 'react';
import { Save } from 'lucide-react';
import { kleur } from '../../../theme/tokens';
import { basis } from '../stijlen';

const SCHUIVEN = [
  ['p_bronnen', 'Bronverwijzing'], ['p_cv_detail', 'CV detail'], ['p_referentie', 'Referentie'],
];

export function AgentRollen({ api }) {
  const [rollen, setRollen] = useState([]);
  const [laden, setLaden] = useState(false);

  const haalRollen = async () => {
    setLaden(true);
    try {
      const data = await api.haalAgentRollen();
      if (data.success) setRollen(data.data);
    } catch (err) { console.error('Fout:', err); }
    finally { setLaden(false); }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { haalRollen(); }, []);

  const wijzig = (id, veld, waarde) => setRollen(rollen.map(r => (r.id === id ? { ...r, [veld]: waarde } : r)));

  const slaOp = async (rol) => {
    try {
      const data = await api.wijzigAgentRol(rol);
      if (data.success) haalRollen();
    } catch (err) { console.error('Fout:', err); }
  };

  const schuif = (rol, veld, label, min, max) => (
    <div style={styles.sliderGroup}>
      <label>{label}: {rol[veld]}</label>
      <input type="range" min={min} max={max} step="0.1" value={rol[veld]}
        onChange={(e) => wijzig(rol.id, veld, parseFloat(e.target.value))} style={styles.slider} />
    </div>
  );

  return (
    <div style={styles.card}>
      <h2>Agent-rollen configuratie</h2>
      <p style={styles.beschrijving}>Pas de parameters per agent-rol aan met de schuifknoppen.</p>
      {laden ? <p>Laden...</p> : (
        <div style={styles.rollenGrid}>
          {rollen.map((rol) => (
            <div key={rol.id} style={styles.rolCard}>
              <div style={styles.rolHeader}>
                <h3>{rol.agent_rol}</h3>
                {rol.agent_rol !== 'discussieleider' ? (
                  <label style={styles.checkboxLabel}>
                    <input type="checkbox" checked={rol.is_active} onChange={(e) => wijzig(rol.id, 'is_active', e.target.checked)} />
                    Actief
                  </label>
                ) : (
                  <span style={{ color: 'black' }}>Altijd actief</span>
                )}
              </div>
              <div style={styles.bronInfo}><strong>Bron:</strong> {rol.bron || '-'}</div>
              <input type="text" value={rol.beschrijving || ''} onChange={(e) => wijzig(rol.id, 'beschrijving', e.target.value)}
                placeholder="Beschrijving" style={styles.rolInput} />
              {schuif(rol, 'tokens_factor', 'Tokens factor', '0.5', '2.0')}
              {rol.agent_rol !== 'discussieleider' && SCHUIVEN.map(([veld, label]) => (
                <React.Fragment key={veld}>{schuif(rol, veld, label, '0', '1')}</React.Fragment>
              ))}
              <button onClick={() => slaOp(rol)} style={styles.saveBtn}><Save size={14} /> Opslaan</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const styles = {
  ...basis,
  rollenGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px', marginTop: '20px' },
  rolCard: { background: kleur.vlak, borderRadius: '12px', padding: '20px', border: `1px solid ${kleur.lijn}` },
  rolHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' },
  rolInput: { width: '100%', padding: '8px', border: `1px solid ${kleur.lijnZacht}`, borderRadius: '6px', marginBottom: '16px', boxSizing: 'border-box' },
  sliderGroup: { marginBottom: '16px' },
  slider: { width: '100%', height: '8px', borderRadius: '4px', appearance: 'none', background: kleur.lijn, outline: 'none', cursor: 'pointer' },
};
